import { optionsMap } from 'pro-gallery-lib';
import { PRIVATE_CONTROLLERS } from '../controllers/private-controllers';
export var layoutOptions = {
    layouts: [optionsMap.layoutParams.structure.galleryLayout],
    tabs: [
        {
            label: 'ProGallery_Layout_Layouts_Gallery_Header',
            options: [
                optionsMap.layoutParams.structure.layoutOrientation,
                optionsMap.behaviourParams.gallery.layoutDirection,
                optionsMap.layoutParams.structure.scrollDirection,
                PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_METHOD,
                PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_VALUE,
                optionsMap.layoutParams.crop.method,
                optionsMap.layoutParams.crop.ratios,
                {
                    DESIGN_SETTINGS: [
                        optionsMap.layoutParams.structure.responsiveMode,
                        optionsMap.layoutParams.targetItemSize.value,
                        optionsMap.layoutParams.structure.itemSpacing,
                        optionsMap.layoutParams.groups.density,
                        optionsMap.layoutParams.structure.numberOfGridRows,
                        optionsMap.layoutParams.structure.numberOfColumns,
                        optionsMap.layoutParams.thumbnails.alignment,
                        optionsMap.layoutParams.thumbnails.size,
                        optionsMap.layoutParams.thumbnails.spacing,
                        optionsMap.layoutParams.navigationArrows.enable,
                        optionsMap.layoutParams.navigationArrows.size,
                        optionsMap.layoutParams.navigationArrows.padding,
                        optionsMap.layoutParams.navigationArrows.position,
                        // optionsMap.layoutParams.navigationArrows.container.type,
                        optionsMap.layoutParams.navigationArrows.verticalAlignment,
                        optionsMap.behaviourParams.gallery.horizontal.slideTransition,
                        optionsMap.behaviourParams.item.content.magnificationValue,
                        optionsMap.behaviourParams.gallery.vertical.loadMore.enable,
                        optionsMap.behaviourParams.gallery.vertical.loadMore.amount,
                        optionsMap.behaviourParams.gallery.vertical.loadMore.text,
                    ],
                },
                {
                    SLIDESHOW_SETTINGS: [
                        optionsMap.behaviourParams.gallery.horizontal.loop,
                        optionsMap.behaviourParams.gallery.horizontal.autoSlide.behaviour,
                        optionsMap.behaviourParams.gallery.horizontal.autoSlide.interval,
                        optionsMap.behaviourParams.gallery.horizontal.autoSlide.speed,
                        optionsMap.behaviourParams.gallery.horizontal.autoSlide
                            .pauseOnHover,
                        optionsMap.behaviourParams.gallery.horizontal.navigationDuration,
                    ],
                },
            ],
            id: 'gallery',
        },
        {
            label: 'ProGallery_Layout_DisplaySection_Header',
            options: [
                PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE_AND_DESCRIPTION,
                PRIVATE_CONTROLLERS.INFO.INTERNAL_MASTER_INFO_ORDER,
                optionsMap.behaviourParams.item.overlay.hoveringBehaviour,
                PRIVATE_CONTROLLERS.INFO.EXTERNAL_MASTER_INFO_ORDER,
                optionsMap.layoutParams.info.placement,
                PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN,
                PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN,
                optionsMap.layoutParams.info.sizeUnits,
                PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL,
                PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT,
                optionsMap.layoutParams.info.height,
                PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING,
                PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING,
                {
                    OVERLAY: [
                        PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE,
                        optionsMap.behaviourParams.item.overlay.sizeUnits,
                        PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT,
                        PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL,
                        optionsMap.behaviourParams.item.overlay.position,
                        optionsMap.behaviourParams.item.overlay.padding,
                    ],
                },
            ],
            isExperimental: false,
            id: 'info',
        },
    ],
};
//# sourceMappingURL=layoutOptions.js.map